module.exports = __webpack_public_path__ + "img/shop1.d8d7d36f.png";